<template>
    <article class="postCard">
        <a
            :href="article.url"
            class="bareLink"
            tabindex="-1"
            :aria-label="`Read article: ${article.title}`"
        >
            <figure class="postCard__image responsiveImage">
                <picture>
                    <source
                        data-sizes="auto"
                        :data-srcset="this.article.img.webp_src_set"
                        type="image/webp"
                    >
                    <img
                        :data-srcset="this.article.img.src_set"
                        data-sizes="auto"
                        class="lazyload"
                        alt=""
                    >
                </picture>
            </figure>
        </a>
        <div class="postCard__content">
            <p
                class="cardMeta"
                :class="article.category_modifiers"
            >
                <span v-if="article.category" class="cardMeta__category">{{ article.category }}</span>
                <span v-if="article.category" class="cardMeta__separator">-</span>
                <time class="cardMeta__time">
                    {{ article.date }}
                    {{ article.end_date ? `– ${article.end_date}` : '' }}
                </time>
                <span v-if="article.readTimeInMinutes">
                    &bull;
                </span>
                <span class="cardMeta__readTime" v-if="article.readTimeInMinutes">
                    {{article.readTimeInMinutes}} min read
                </span>
            </p>
            <h2 class="postCard__heading">
                <a
                    :href="article.url"
                    class="bareLink"
                >
                    {{ article.title }}
                </a>
            </h2>
            <p class="postCard__info">
                <img
                    class="author_smallIcon"
                    :src="article.authorImg"
                    alt=""
                    v-if="article.author"
                />
                <span
                    class="author"
                    v-if="article.author"
                    v-text="article.author"
                />
                <span
                    v-if="article.location"
                    v-text="article.location"
                />
                <span v-if="article.location && article.startTime">|</span>
                <span
                    v-if="article.startTime"
                    v-text="article.startTime"
                />
            </p>
            <div class="postCard__arrow">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="arrowRight"
                    fill="currentColor"
                    aria-hidden="true"
                    focusable="false"
                    width="16.181"
                    height="10.8"
                    viewBox="0 0 16.181 10.8"
                ><path
                    data-name="Path 2028"
                    d="M0 6.3h12.738L9.52 9.531l1.267 1.269 5.394-5.4L10.787 0 9.52 1.269 12.738 4.5H0z"
                /></svg>
            </div>
        </div>
    </article>
</template>

<script>
export default {
    name: 'PostCard',
    props: {
        article: {
            type: Object,
            required: true,
        },
    },
}
</script>
